import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {map, tap} from "rxjs/operators";

const endpointGetDownloads = environment.downloadsApiUrl;

@Injectable({
  providedIn: 'root'
})
export class DownloadsService {

  constructor(
    private http: HttpClient
  ) {
  }
  getProjectDownloads() {
    return this.http.get(endpointGetDownloads).pipe(
      tap(res => res),
      map(res => res)
    );
  }
}
